import React from 'react'
import './process.css';

function Process() {
  return (
    <div className='pbody'>
      <div class="pcontainer">
   <div class="header">
    <i class="fas fa-seedling">
    </i>
    Work Process
   </div>
   <div class="subheader">
    The Agriculture Process
   </div>
   <div class="process">
    <div class="process-item" data-aos="fade-right">
     <img alt="Image of a tractor in a field" height="100" src="https://cdn.pixabay.com/photo/2015/05/14/02/22/soil-766281_1280.jpg" width="100"/>
     <h3>
      Planning
     </h3>
     <p>
     We plan smartly for better yields and sustainable results.
     </p>
    </div>
    <div class="process-item" data-aos="fade-right">
     <img alt="Image of hands planting a seedling" height="100" src="https://cdn.pixabay.com/photo/2023/10/24/16/57/plant-8338691_1280.jpg" width="100"/>
     <h3>
      Growing
     </h3>
     <p>
     We nurture crops for optimal growth and quality.
     </p>
    </div>
    <img data-aos="flip-right" alt="Image of a wooden crate filled with vegetables" class="center-image" height="300" src="https://cdn.pixabay.com/photo/2023/09/25/16/18/agriculture-8275498_1280.jpg" width="300"/>
    <div class="process-item" data-aos="fade-left">
     <img alt="Image of a field being harvested" height="100" src="https://cdn.pixabay.com/photo/2022/06/10/12/46/reaper-binder-7254433_1280.jpg" width="100"/>
     <h3>
      Harvesting
     </h3>
     <p>
     Our harvest ensures maximum freshness and flavor.
     </p>
    </div>
    <div class="process-item" data-aos="fade-left">
     <img alt="Image of a processing plant" height="100" src="https://cdn.pixabay.com/photo/2023/06/22/04/19/rye-8080482_1280.jpg" width="100"/>
     <h3>
      Processing
     </h3>
     <p>
     We process carefully to retain natural goodness.
     </p>
    </div>
   </div>
   <div class="dashed-line">
   </div>
  
  </div>
    </div>
  )
}

export default Process
